import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/catalogos/permisos-de-tipos-de-placas/';

/**
 * GET permisosDeTipoDePlaca
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getPermisosDeTipoDePlaca = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET TipoDePlaca
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getPermisoDeTipoDePlaca = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Tipo De Placa
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPermisoTipoDePlaca = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo De Placa
 * @param {number} id
 * @param {object} _values
 * @returns {Promise<object|boolean>}
 */
export const patchPermisoTipoDePlaca = async (id, _values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, _values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE Tipo De Placa
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deletePermisoTipoDePlaca = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
